///home/clement/compta-app/client/src/api/budgetProjetApi.js

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchBudgetProjet = async (projetId) => {
  const response = await axios.get(`${API_URL}/projet/${projetId}`);
  return response.data;
};
